import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  AfterViewChecked,
} from "@angular/core";

@Component({
  selector: "chat-detail",
  templateUrl: "./chat-detail.component.html",
  styleUrls: ["./chat-detail.component.scss"],
})
export class ChatDetailComponent implements OnInit, AfterViewChecked {
  @Input() receiver;
  @Input() sender;
  @Input() conversation;
  @Output() messageEvent = new EventEmitter<string>();
  private textMessage = "";

  constructor() {}

  ngOnInit() {}

  ngAfterViewChecked() {
    this.updateScroll();
  }

  sendMessage() {
    this.messageEvent.emit(this.textMessage);
    this.textMessage = "";
  }
  updateScroll() {
    var element = document.getElementById("messageArea");
    element.scrollTop = element.scrollHeight;
  }
}
